import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { Dictionary } from '../../../../shared/models/dictionary';
import { EntityTypes } from '../../../entity/entity-types';
import { getDictionaryTagListState } from '../tag.reducer';
import { createEntitiesSelector } from '../../../entity/entities.reducer';
import { createSymfonyTotalCountSelector } from '../../../symfony/list/selectors/list.selectors';
import { Entities } from '../../../entity/entities';
import { EntityState } from '../../../entity/entity.reducer';

const createState = (id: IdType) => createSelector(
  getDictionaryTagListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateByContext = (id: IdType) => createListStateIdsSelector(createState(id));

export const createDictionaryTagListData = (id: IdType) => createSelector(
  createStateByContext(id),
  createEntitiesSelector([
    EntityTypes.tag
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.tag]], entities) as Dictionary[]
);

export const createDictionaryTagListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createDictionaryTagListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createDictionaryTagListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createDictionaryTagListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createDictionaryTagListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
